import type {PreloadedEntryPoint} from 'react-relay/relay-hooks/EntryPointTypes'

import type {UserProperty} from '../../../utils/userProperties'
import {UserProperties} from '../../../utils/userProperties'
import type {AgentsSidebarRelayContainerComponent} from '../../pages/AgentsPages/AgentsSidebar/AgentsSidebar'

import type {PipelinesSidebarContentComponent} from './SidebarPanelContent/PipelinesSidebar/PipelinesSidebarContent/PipelinesSidebarContent'
import type {ProjectsSidebarOuterContainerComponent} from './SidebarPanelContent/ProjectsSidebar/ProjectsSidebar.container'
import type {QueueSidebarContainerComponent} from './SidebarPanelContent/QueueSidebar/QueueSidebar'

export enum SidebarType {
  AGENTS = 'agents',
  QUEUE = 'queue',
  PROJECTS = 'projects',
}

export const SIDEBAR_PINNED_PROPERTIES: Record<SidebarType, UserProperty> = {
  [SidebarType.AGENTS]: UserProperties.SIDEBAR_PINNED_AGENTS,
  [SidebarType.QUEUE]: UserProperties.SIDEBAR_PINNED_QUEUE,
  [SidebarType.PROJECTS]: UserProperties.SIDEBAR_PINNED_PROJECTS,
}

export const getSidebarPinnedProperty = (sidebarId: SidebarType): UserProperty =>
  SIDEBAR_PINNED_PROPERTIES[sidebarId]

export type Props = {
  offsetBottom?: number
  projectsSidebarEntryPoint?: PreloadedEntryPoint<ProjectsSidebarOuterContainerComponent>
  queueSidebarEntryPoint?: PreloadedEntryPoint<QueueSidebarContainerComponent>
  agentsSidebarEntryPoint?: PreloadedEntryPoint<AgentsSidebarRelayContainerComponent>
  pipelinesSidebarContentEntryPoint?: PreloadedEntryPoint<PipelinesSidebarContentComponent>
  onResize?: (width: number) => void
}
